export const usedByOption = [

    { label: 'Gender', value: 'Gender' },
    { label: 'Status', value: 'Status' },
    { label: 'SeatStatus', value: 'SeatStatus' }, 
    { label: 'Brand', value: 'Brand' }, 
    { label: 'Vendor', value: 'Vendor' }, 
    { label: 'ProductType', value: 'ProductType' }, 


];
